import { render, staticRenderFns } from "./PrincipalContact.vue?vue&type=template&id=35854b71&"
import script from "./PrincipalContact.vue?vue&type=script&lang=js&"
export * from "./PrincipalContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports